var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$options.components[_vm.action.component] && _vm.hasPermission())?_c(_vm.action.component,{tag:"component",attrs:{"action":_vm.action,"masterItem":_vm.masterItem,"manager":_vm.manager,"enabled":_vm.action.enabled}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }